// Copyright (c) 2017-2024 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export const ARCHIVAL_STATUS_LIST = [
  { value: '-1', label: 'Closed' },
  { value: '0', label: 'Completed' },
  { value: '1', label: 'Failed' },
  { value: '2', label: 'Cancelled' },
  { value: '3', label: 'Terminated' },
  { value: '4', label: 'Continued As New' },
  { value: '5', label: 'Timed Out' },
];

export const DEFAULT_RANGE = 'last-24-hours';

export const LOADING_MESSAGE_DELAY = 3000;



// WEBPACK FOOTER //
// ./client/routes/domain/workflow-archival/constants.js